import * as type from './constant';

export const getConfirmation = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getConfirmationSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getConfirmationError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addConfirmation = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addConfirmationSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateConfirmation = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateConfirmationSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteConfirmation = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteConfirmationSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationConfirmationError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
